export default {
  name: 'appFooter',
  data() {
    return {}
  },
  created() {},
  method: {}
}
